module.exports = __webpack_public_path__ + "static/media/Desktop_Skills_4.07708a83.png";